import type { planEnrollmentApiSpec } from "@wingspanhq/wingspan-api-types";
import { meridioPlanEnrollmentService } from "./service";

type IPlanEnrollment = planEnrollmentApiSpec.PlanEnrollment;

export const listActiveMeridioPlanEnrollments = async (): Promise<
  IPlanEnrollment[]
> => {
  const { data } = await meridioPlanEnrollmentService.get("");
  return data;
};
